import React from 'react';
import { Avatar } from 'antd';

const bgColors = [
  '#559EF2', // black
  // '#FF6B6B', // coral red
  // '#4ECDC4', // turquoise
  // '#45B7D1', // sky blue  
  // '#96CEB4', // sage green
  // '#FFEEAD', // cream yellow
  // '#D4A5A5'  // dusty rose
];

const AvatarUser = ({ extra, size = 'default', className }) => {
  
  // Get random background color
  const randomColor = bgColors[Math.floor(Math.random() * bgColors.length)];

  // Get initials from name if available in extra
  const getInitials = () => {
    if (extra?.full_name) {
      return extra.full_name.match(/\b\w/g).join('').toUpperCase();
    }
    return '?';
  };

  // Render avatar with image if valid path exists
  if (extra?.profile_image && typeof extra.profile_image === 'string' && extra.profile_image.trim() !== '') {
    return (
      <Avatar 
        size={size}
        src={extra.profile_image}
        {...extra}
        className={className}
      />
    );
  }

  // Otherwise render avatar with initials
  return (
    <Avatar
      size={size}
      style={{ 
        backgroundColor: randomColor,
        verticalAlign: 'middle'
      }}
      {...extra}
    >
      {getInitials()}
    </Avatar>
  );
};

export default AvatarUser;
